package com.dotdrives.web.pages

import react.FC
import react.Props
import react.dom.html.ReactHTML.style

private val signInStyles = """
    @keyframes floatY {
      0%, 100% { transform: translateY(0); }
      50% { transform: translateY(-10px); }
    }
    @keyframes dotTravel {
      0% { left: 2%; }
      30% { left: 32%; }
      36% { left: 32%; }
      66% { left: 64%; }
      72% { left: 64%; }
      98% { left: 95%; }
      100% { left: 95%; }
    }
    @keyframes popIn {
      0% { transform: translateY(14px); opacity: 0; }
      100% { transform: translateY(0); opacity: 1; }
    }
    @keyframes pulse {
      0%, 100% { opacity: 1; }
      50% { opacity: .45; }
    }
    @keyframes signin-fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }

    .signin-page {
      min-height: 100vh;
      display: flex;
      overflow: hidden;
      background: #222D32;
    }
    .signin-story {
      position: relative;
      width: 560px;
      min-width: 560px;
      min-height: 100vh;
      display: flex;
      flex: 0 0 auto;
      flex-direction: column;
      overflow: hidden;
      padding: 56px;
      color: white;
      background: #222D32;
    }
    .signin-story-brand {
      position: relative;
      z-index: 1;
      width: fit-content;
      font-family: 'Quicksand', sans-serif;
      font-size: 22px;
      font-weight: 600;
      letter-spacing: -.8px;
    }
    .signin-story-brand-period, .signin-mobile-logo span { color: #F26223; }
    .signin-story-brand-dot {
      position: absolute;
      right: 29px;
      bottom: -10px;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #F26223;
    }
    .signin-story-content { width: min(100%, 400px); margin: auto 0; }
    .signin-story-title {
      margin: 0 0 16px;
      font-size: 40px;
      line-height: 1.15;
      letter-spacing: -1px;
    }
    .signin-story-copy {
      max-width: 380px;
      margin: 0 0 40px;
      color: #AEBBC3;
      font-size: 16px;
      line-height: 1.7;
    }
    .signin-drive-card {
      position: relative;
      max-width: 400px;
      padding: 22px 24px;
      border: 1px solid rgba(255,255,255,.09);
      border-radius: 16px;
      background: rgba(255,255,255,.05);
    }
    .signin-drive-title {
      margin-bottom: 4px;
      font-family: 'Quicksand', sans-serif;
      font-size: 14px;
      font-weight: 700;
    }
    .signin-drive-meta {
      margin-bottom: 16px;
      color: #A8B5BD;
      font-family: 'IBM Plex Mono', monospace;
      font-size: 10px;
    }
    .signin-drive-track {
      position: relative;
      height: 5px;
      margin: 0 6px;
      border-radius: 3px;
      background: rgba(255,255,255,.12);
    }
    .signin-drive-current {
      position: absolute;
      top: -6px;
      left: 2%;
      width: 16px;
      height: 16px;
      border: 3px solid #222D32;
      border-radius: 50%;
      background: #F26223;
      box-shadow: 0 0 14px rgba(242,98,35,.8);
      animation: dotTravel 8s ease-in-out infinite;
    }
    .signin-drive-phases {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      margin-top: 11px;
      color: #C9D3D9;
      font-family: 'Quicksand', sans-serif;
      font-size: 10px;
      font-weight: 700;
    }
    .signin-drive-phases span { text-align: center; }
    .signin-story-copyright { color: #A8B5BD; font-size: 12px; }
    .signin-story-dot {
      position: absolute;
      border-radius: 50%;
      pointer-events: none;
      animation: floatY 6s ease-in-out infinite;
    }
    .signin-story-dot-orange {
      width: 14px;
      height: 14px;
      top: 90px;
      left: 110px;
      background: #F26223;
      opacity: .6;
    }
    .signin-story-dot-blue {
      width: 10px;
      height: 10px;
      bottom: 130px;
      left: 260px;
      background: #4696EC;
      opacity: .5;
      animation-duration: 8s;
    }
    .signin-story-dot-green {
      width: 11px;
      height: 11px;
      top: 220px;
      left: 420px;
      background: #00A65A;
      opacity: .5;
      animation-duration: 7s;
    }
    .signin-stage {
      min-width: 0;
      min-height: 100vh;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 44px;
      border-radius: 20px 0 0 20px / 40px 0 0 40px;
      background: #EFF1F4;
    }
    .signin-mobile-brand { display: none; }
    .signin-card {
      width: min(100%, 420px);
      padding: 38px 40px;
      border-radius: 22px;
      background: white;
      box-shadow: 0 30px 80px rgba(34,45,50,.14);
      animation: popIn .5s ease both;
    }
    .signin-audience {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 4px;
      margin-bottom: 22px;
      padding: 4px;
      border-radius: 99px;
      background: #EFF1F4;
    }
    .signin-audience-option {
      min-height: 36px;
      padding: 9px;
      border: 0;
      border-radius: 99px;
      color: var(--dot-muted);
      background: transparent;
      cursor: pointer;
      font-size: 13px;
      font-weight: 800;
    }
    .signin-audience-option-active {
      color: white;
      background: #222D32;
      box-shadow: 0 2px 7px rgba(34,45,50,.16);
    }
    .signin-audience-giver-active { background: var(--dot-action); }
    .signin-title {
      margin: 0;
      font-size: 25px;
      line-height: 31px;
      letter-spacing: -.4px;
    }
    .signin-aux-title { font-size: 20px; line-height: 26px; }
    .signin-new-copy {
      margin: 4px 0 22px;
      color: var(--dot-muted);
      font-size: 13.5px;
    }
    .signin-giver-copy {
      margin: 4px 0 22px;
      color: var(--dot-muted);
      font-size: 13.5px;
      line-height: 1.55;
    }
    .signin-inline-link, .signin-forgot, .signin-back-link {
      padding: 0;
      border: 0;
      color: var(--dot-action-text);
      background: transparent;
      cursor: pointer;
      font-weight: 800;
    }
    .signin-inline-link:hover, .signin-forgot:hover, .signin-back-link:hover { color: #DA571F; }
    .signin-banner { margin-bottom: 14px; }
    .signin-banner.dot-tone-danger {
      border-color: #F5B5A5;
      color: #C22C25;
      background: #FDECEA;
      font-size: 12.5px;
      font-weight: 700;
    }
    .signin-provider-button {
      width: 100%;
      min-height: 43px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      margin-top: 9px;
      border: 1.5px solid #E4E8EC;
      border-radius: 99px;
      color: #222D32;
      background: white;
      cursor: pointer;
      font-size: 14px;
      font-weight: 800;
    }
    .signin-provider-button:hover:not(:disabled) { border-color: #B4BCC2; background: #F7F8FA; }
    .signin-provider-button:disabled, .signin-magic-button:disabled { opacity: .5; cursor: wait; }
    .signin-google-logo { color: #4285F4; font-family: Arial, sans-serif; font-size: 17px; font-weight: 800; }
    .signin-ms-logo {
      width: 15px;
      height: 15px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1.5px;
    }
    .signin-ms-logo span:nth-child(1) { background: #F25022; }
    .signin-ms-logo span:nth-child(2) { background: #7FBA00; }
    .signin-ms-logo span:nth-child(3) { background: #00A4EF; }
    .signin-ms-logo span:nth-child(4) { background: #FFB900; }
    .signin-divider {
      display: flex;
      align-items: center;
      gap: 12px;
      margin: 16px 0;
      color: var(--dot-muted);
      font-size: 11px;
      font-weight: 700;
    }
    .signin-divider::before, .signin-divider::after {
      content: '';
      height: 1px;
      flex: 1;
      background: #E4E8EC;
    }
    .signin-form { display: grid; gap: 12px; }
    .signin-form .dot-field { background: white; }
    .signin-form .dot-field-label { margin-bottom: 5px; font-size: 12px; font-weight: 800; }
    .signin-password-group { display: grid; gap: 5px; }
    .signin-password-label-row { display: flex; align-items: center; justify-content: space-between; }
    .signin-password-label-row .dot-field-label { margin: 0; }
    .signin-forgot { font-size: 11.5px; }
    .signin-password-field { position: relative; }
    .signin-password-field .dot-field { padding-right: 42px; }
    .signin-password-toggle {
      position: absolute;
      top: 50%;
      right: 13px;
      width: 26px;
      height: 26px;
      transform: translateY(-50%);
      border: 0;
      border-radius: 50%;
      color: var(--dot-muted);
      background: transparent;
      cursor: pointer;
    }
    .signin-credential-error .dot-field {
      border: 2px solid #C22C25;
      padding: 11px 14px;
    }
    .signin-primary { min-height: 44px; margin-top: 2px; }
    .signin-magic-button {
      width: 100%;
      min-height: 42px;
      margin-top: 10px;
      border: 1.5px solid #FDE5DA;
      border-radius: 99px;
      color: var(--dot-action-text);
      background: #FEF8F6;
      cursor: pointer;
      font-size: 13px;
      font-weight: 800;
    }
    .signin-magic-button:hover:not(:disabled) { border-color: #F26223; }
    .signin-footer { margin-top: 14px; color: var(--dot-muted); text-align: center; font-size: 11px; }
    .signin-footer a, .signin-terms a { color: var(--dot-muted); text-decoration: none; }
    .signin-help-copy {
      margin: 6px 0 16px;
      color: #5A6870;
      font-size: 13px;
      line-height: 1.6;
    }
    .signin-back-link { display: block; margin: 14px auto 0; font-size: 12.5px; }
    .signin-info-note {
      margin-top: 16px;
      padding: 11px 14px;
      border: 1px solid #FBCEBA;
      border-radius: 11px;
      color: var(--dot-action-text);
      background: #FEF8F6;
      font-size: 11.5px;
      line-height: 1.55;
    }
    .signin-giver-form { margin-top: 0; }
    .signin-giver-google { margin: 0 0 16px; }
    .signin-giver-note { margin-top: 0; color: #5A6870; background: #F7F8FA; border-color: transparent; font-size: 12px; }
    .signin-sent { padding: 0; text-align: center; }
    .signin-sent-icon {
      margin-bottom: 12px;
      font-size: 40px;
      line-height: 1;
      animation: pulse 2s infinite;
    }
    .signin-sent-copy {
      margin: 8px 0 16px;
      color: #5A6870;
      font-size: 13.5px;
      line-height: 1.65;
    }
    .signin-giver-sent-note { margin: 0 0 14px; padding: 12px 15px; border-radius: 12px; font-size: 12px; }
    .signin-resend {
      margin-bottom: 14px;
      padding: 11px 14px;
      border-radius: 12px;
      color: var(--dot-muted);
      background: #F7F8FA;
      font-size: 12px;
    }
    .signin-resend-link { font-size: inherit; }
    .signin-resend-link:disabled { color: var(--dot-action-text); cursor: default; opacity: 1; }
    .signin-terms { margin-top: 12px; color: var(--dot-muted); text-align: center; font-size: 10.5px; }
    .signin-strength { margin-top: 1px; }
    .signin-strength-bars { display: flex; gap: 5px; margin-bottom: 4px; }
    .signin-strength-bars span { height: 4px; flex: 1; border-radius: 2px; background: #EFF1F4; }
    .signin-strength-bars .signin-strength-active { background: #00A65A; }
    .signin-strength-copy { color: var(--dot-positive); font-size: 11px; font-weight: 700; }

    .reset-page {
      min-height: 100vh;
      display: grid;
      place-items: center;
      padding: 24px;
      background: #EFF1F4;
    }
    .reset-card {
      width: min(100%, 440px);
      padding: 40px;
      border: 1px solid #E4E8EC;
      border-radius: 20px;
      background: white;
      box-shadow: 0 24px 70px rgba(34,45,50,.12);
      animation: popIn .5s ease both;
    }
    .reset-brand { margin-bottom: 24px; font-family: 'Quicksand', sans-serif; font-size: 19px; font-weight: 700; }
    .reset-title { font-size: 27px; line-height: 34px; }
    .reset-copy { margin: 8px 0 24px; color: #5A6870; line-height: 1.55; }
    .reset-form { display: grid; gap: 16px; margin-top: 16px; }
    .reset-back-link { color: var(--dot-action-text); font-size: 13px; font-weight: 800; text-decoration: none; }

    .giving-portal {
      min-height: 100vh;
      color: white;
      background: #222D32;
    }
    .giving-portal-header {
      min-height: 76px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 32px;
      border-bottom: 1px solid rgba(255,255,255,.08);
    }
    .giving-portal-brand { font-family: 'Quicksand', sans-serif; font-size: 20px; font-weight: 700; }
    .giving-portal-period { color: #F26223; }
    .giving-portal-signout {
      padding: 8px 0;
      border: 0;
      color: #AEBBC3;
      background: transparent;
      cursor: pointer;
      font-weight: 700;
    }
    .giving-portal-content {
      width: min(100% - 40px, 620px);
      margin: 0 auto;
      padding: 112px 0;
      text-align: center;
      animation: popIn .5s ease both;
    }
    .giving-portal-eyebrow { color: var(--dot-muted); font-family: 'IBM Plex Mono', monospace; font-size: 10px; letter-spacing: .7px; }
    .giving-portal-title { margin: 12px 0 8px; font-size: 38px; }
    .giving-portal-copy { margin: 0 auto; color: #AEBBC3; font-size: 16px; line-height: 1.6; }
    .giving-portal-note {
      width: fit-content;
      margin: 34px auto 0;
      padding: 12px 18px;
      border: 1px solid rgba(242,98,35,.35);
      border-radius: 99px;
      color: #F7B392;
      background: rgba(242,98,35,.1);
      font-size: 13px;
      font-weight: 800;
    }

    .signin-audience-option:focus-visible, .signin-provider-button:focus-visible,
    .signin-inline-link:focus-visible, .signin-forgot:focus-visible,
    .signin-password-toggle:focus-visible, .signin-magic-button:focus-visible,
    .signin-back-link:focus-visible, .reset-back-link:focus-visible,
    .giving-portal-signout:focus-visible {
      outline: 2px solid var(--dot-focus);
      outline-offset: 2px;
    }

    @media (max-width: 1100px) {
      .signin-story { width: 470px; min-width: 470px; padding: 48px; }
      .signin-story-dot-green { left: 400px; }
      .signin-stage { padding: 32px; }
    }
    @media (max-width: 900px) {
      .signin-page { display: block; overflow: visible; background: #222D32; }
      .signin-story { display: none; }
      .signin-stage {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding: 0;
        border-radius: 0;
        background: #222D32;
      }
      .signin-mobile-brand {
        width: 100%;
        display: block;
        padding: 56px 24px 30px;
        color: white;
        text-align: center;
      }
      .signin-mobile-logo { margin-bottom: 14px; font-family: 'Quicksand', sans-serif; font-size: 20px; font-weight: 700; }
      .signin-mobile-title { margin: 0; font-size: 23px; }
      .signin-card {
        width: calc(100% - 36px);
        max-width: 420px;
        margin: 0 18px 32px;
        padding: 24px 22px;
        align-self: center;
      }
    }
    @media (max-width: 430px) {
      .signin-mobile-brand { padding-top: 48px; }
      .signin-card { width: calc(100% - 24px); margin-inline: 12px; }
      .signin-title { font-size: 22px; }
      .signin-new-copy { font-size: 12.5px; }
      .reset-card { padding: 28px 22px; }
      .giving-portal-header { padding-inline: 20px; }
      .giving-portal-content { padding-top: 86px; }
      .giving-portal-title { font-size: 30px; }
    }
    @media (prefers-reduced-motion: reduce) {
      .signin-story-dot, .signin-drive-current, .signin-sent-icon { animation: none !important; }
      .signin-card, .reset-card, .giving-portal-content {
        animation: signin-fadeIn .2s ease both !important;
      }
    }
""".trimIndent()

val SignInStyles = FC<Props> {
    style {
        +signInStyles
    }
}
